import {useNavigate, useRoutes} from "react-router-dom";
import {HomePage} from "./pages/home";
import HomeContainer from "./container/homeContainer";
import NotFoundPage from "./pages/special/NotFound";
import EventDetails from "./pages/event_details";
import ContactPage from "./pages/contact";
import Login from "./pages/auth/login";
import MyTickets from "./pages/tickets";
import Signup from "./pages/auth/signup";
import AllEvents from "./pages/all";
import MySingleTicket from "./pages/ticket";
import ProtectedContainer from "./components/ProtectedContainer";
import PastEventDetails from "./pages/past_event_details";
import AllPastEvents from "./pages/allPast";

export default function AppRouter() {


    return useRoutes([
        {
            path: '/',
            element: <HomeContainer />,
            children: [
                { index: true, element: <HomePage /> },
                { path: '/login', element: <Login /> },
                { path: '/signup', element: <Signup /> },
                { path: '/event/:slug', element: <EventDetails />},
                { path: '/event/past/:slug', element: <PastEventDetails />},
                { path: '/contact-us', element: <ContactPage /> },
                { path: '/ticket/:id', element: <MySingleTicket /> },
                {
                    path: '/tickets',
                    element: <ProtectedContainer>
                        <MyTickets />
                    </ProtectedContainer> },
                { path: '/events', element: <AllEvents /> },
                { path: '/past-events', element: <AllPastEvents /> },
                { path: '*', element: <NotFoundPage /> }
            ]
        }
    ])
};